import React from 'react';

import type { CurrencyRate } from '@models/next/CurrencyRate';
import type {
  InvoiceChargePayDayForm,
  InvoiceDefaultValue,
  InvoiceInfoForm,
  InvoiceDetails,
  InvoiceErrorMessage,
  Invoice,
} from '@models/next/Invoice';

export interface InvoiceFormDialogContextValuesBase {
  type: 'create' | 'update';
  open: boolean;
  onClose: () => void;
  id?: number;
  /**
   * When the invoice is created with FC error,
   * let the host element open an edit dialog for the newly created object.
   */
  onEditInvoice?(id: number): void;
}

export interface InvoiceFormDialogContextValues extends InvoiceFormDialogContextValuesBase {
  step: number;
  setStep: (step: number) => void;
  invoiceDefaultValue?: InvoiceDefaultValue;
  invoiceChargePayDayForm?: InvoiceChargePayDayForm;
  setInvoiceChargePayDayForm(v: InvoiceChargePayDayForm): void;
  invoiceInfoForm?: InvoiceInfoForm;
  setInvoiceInfoForm(v: InvoiceInfoForm): void;
  currencyRates: CurrencyRate[];
  invoiceDetails: InvoiceDetails[];
  selectedInvoiceDetails: InvoiceDetails[];
  setSelectedInvoiceDetails(v: InvoiceDetails[]): void;

  /**
   * Remote error after mutating, for FC errors.
   */
  invoiceErrorMessage?: InvoiceErrorMessage;
  setInvoiceErrorMessage(v: InvoiceErrorMessage | undefined): void;
  /**
   * Remote invoice after mutating.
   */
  invoice?: Invoice;
  setInvoice(v: Invoice | undefined): void;
  refresh(): void;
}

export const InvoiceFormDialogContext = React.createContext<InvoiceFormDialogContextValues>(
  undefined as any,
);
